'use client'

import React, { useEffect, useState } from 'react'
import { Common } from '@/config/NextImport'  
import { HttpService, ServiceEndpoints } from '@/config/NextImport'

 
const StripContent = () => {
  return (
    <> 
      <section className="section strip-content-section mb-0 py-3">
        <div className="container strip-content-container">
          <div className="d-flex marqee-strip-content">
            <span>Crafted in London</span>
            <span>Ethical Sourcing</span>
            <span>Certified Diamonds</span>
            <span>Lifetime  Free Cleaning</span>
            <span>Crafted in London</span>
            <span>Ethical Sourcing</span>
            <span>Certified Diamonds</span>
            <span>Lifetime  Free Cleaning</span>
          </div>
        </div> 
      </section> 
    </>
  )
}

export default StripContent
